import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLinesLongRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.266 5.466v2.667H3.199V5.466zm8.534 5.69v2.666H3.2v-2.666zm-5.69 5.689v2.666H3.2v-2.666zm5.69 5.688v2.666H3.2v-2.666z",
		fill: "currentColor"
	})
});
export default SvgLinesLongRegularIcon;
